var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.closeWindow,
          expression: "closeWindow"
        }
      ],
      staticClass: "object-menu-container",
      style: { left: _vm.xPosition + "px", top: _vm.yPosition + "px" },
      attrs: { "data-app": "" }
    },
    [
      _c("object-menu-item", {
        attrs: { label: _vm.$t("ViewInMap") },
        nativeOn: {
          click: function($event) {
            return _vm.viewInMap.apply(null, arguments)
          }
        }
      }),
      _vm._v(" "),
      _vm.objectType === "node"
        ? _c("object-menu-item", {
            attrs: { label: _vm.$t("ViewInSplicing") },
            nativeOn: {
              click: function($event) {
                return _vm.openSplicing.apply(null, arguments)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("object-menu-item", {
        attrs: { label: _vm.$tc("Detail", 2) },
        nativeOn: {
          click: function($event) {
            return _vm.openZoomIn.apply(null, arguments)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dd2efe3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dd2efe3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Network/ObjectMenu/ObjectMenu.vue
// module id = null
// module chunks = 